export { date, money, saveBlob, str } from '@/app/suppliers/_components/format';

// The table writes the page into the address itself.
export const noop = () => {};

// Address keys that belong to the page, not to a list.
const PAGE_KEYS = ['company', 'tab', 'period'];

/** Everything the list's server call takes from the address: page, column filters, sort. */
export const listQueryOf = (queryParams) =>
  Object.fromEntries(Object.entries(queryParams).filter(([k, v]) => !PAGE_KEYS.includes(k) && v !== undefined && v !== ''));

/** The address keys a list's columns write: its filters and `sort<Column>`. */
export const columnKeysOf = (filters, sorts) => [
  ...filters,
  ...sorts.map((c) => `sort${c.charAt(0).toUpperCase()}${c.slice(1)}`),
];
